import {
    Guid,
    Url
} from '@ef-carbon/primitive';
import isIterable from '../isIterable';
import Type from './Type';
export class LinkRemote {
    constructor({url, method, headers, body, redirect}) {
        this.type = Type.Remote;
        this.url = new Url(url);
        this.headers = {};
        this.method = method;
        this.body = body;
        this.redirect = redirect ? new Guid(redirect) : undefined;
        if (headers) {
            const iterable = isIterable(headers) ? headers : Object.entries(headers);
            for (const [header, value] of iterable) {
                this.headers[header] = value;
            }
        }
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.type.writable = false;
        descriptors.type.configurable = false;
        descriptors.url.configurable = false;
        descriptors.method.configurable = false;
        descriptors.headers.configurable = false;
        descriptors.body.configurable = false;
        descriptors.redirect.configurable = false;
        Object.defineProperties(this, descriptors);
    }
}
export {
    LinkRemote as Remote
};
export const klass = LinkRemote;
export default LinkRemote;    //# sourceMappingURL=Remote.js.map
